import { STEP_CHECK_EMAIL } from './constants';

const initialState = {
  step: STEP_CHECK_EMAIL,
  zone: null,
  data: {},
};

export default initialState;
